import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ChevronRight, ChevronLeft } from '@insurancemenu/imenu-components-lib/dist/icons';
import FormsSpinner from 'components/common/general/FormSpinner';
import CriteriaBullets from './CriteriaBullets';
import { createStyles } from './styles';

export interface CriteriaProps {
  currentIndex: number;
  totalQuantity: number;
  loading?: boolean;
  minHeight?: string;
  onContinue: () => void;
  onBack: () => void;
  children: React.ReactNode;
}

const Criteria: React.FC<CriteriaProps> = ({
  currentIndex,
  totalQuantity,
  loading = false,
  onContinue,
  onBack,
  children,
  minHeight,
}) => {
  const classes = createStyles({ minHeight });
  return (
    <div className={classes.formTemplate}>
      <FormsSpinner display={loading} />
      <CriteriaBullets
        currentIndex={currentIndex}
        totalQuantity={totalQuantity}
        className={classes.formCriteriaNavBar}
      />
      <div className={classes.content}>{children}</div>
      <footer className={classes.actionButtons}>
        <Button
          leftIconProp={<ChevronLeft />}
          type="outlined"
          size="large"
          onClick={onBack}
          className={classes.backButton}
        >
          Back
        </Button>
        <Button rightIconProp={<ChevronRight />} color="primary" size="large" onClick={onContinue}>
          Next
        </Button>
      </footer>
    </div>
  );
};

export default Criteria;
